export default __webpack_public_path__ + "static/media/sideeffects@2x.e31e7623.jpg";